import { Injectable } from '@angular/core';
import {FuncsService} from '../../../shared/funcs.service';
import {ValidationErrors} from '@angular/forms';
import {LoginService} from "../login.service";

@Injectable()
export class UsernamePasswordService {
  readonly autoLoginQrCode$ = this.loginService.autoLoginQrCode$;

  constructor(
    private func: FuncsService,
    private loginService: LoginService
  ) { }

  getValidationErrorMessage(errors: ValidationErrors): string {
    return this.func.getValidationErrorMessage(errors);
  }
}
